/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Folder_CreatedInputs */

const cs_enum_folder_created = /** @type {(inputs: Enum_Folder_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Složka vytvořena`)
};

const en_enum_folder_created = /** @type {(inputs: Enum_Folder_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder created`)
};

/**
* | output |
* | --- |
* | "Folder created" |
*
* @param {Enum_Folder_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_folder_created = /** @type {((inputs?: Enum_Folder_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Folder_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_folder_created(inputs)
	return cs_enum_folder_created(inputs)
});